module.exports = __webpack_public_path__ + "img/toolPic6.069d17a2.png";